import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  index() {
    const url = FetchHelpers.toCDN(apiRoutes.pillsPath(1));
    return FetchHelpers.get(url);
  },
};
